<ul class="bmc-user-groups-conditions bz-color-border--neutral-300" *ngIf="menuOptions">
    <li class="bmc-user-groups-conditions__item" *ngFor="let condition of currentUserGroup.conditions; let i = index">
      <div class="bmc-user-groups-conditions-header">
        <h4 class="bmc-user-groups-conditions-header__text bz-color-border--neutral-300 bz-space--inline-s">
          {{("USER_GROUPS.CONDITION" | translate) + ' ' + ( i + 1 )}}
        </h4>
        <p *ngIf="!expanded[i]" class="bmc-user-groups-conditions-header__is-included">
          <span *ngIf="condition.exclude">
          {{'USER_GROUPS_CONDITIONS.EXCLUDED' | translate}}
       </span>
          <span *ngIf="!condition.exclude">
          {{'USER_GROUPS_CONDITIONS.INCLUDED' | translate}}
       </span>
        </p>
       <bzg-icon *ngIf="menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageConditions]]" [nameIcon]="'icon-delete'" class="bmc-user-groups-conditions-header__icon-delete" (click)="removeCondition(condition)"></bzg-icon>
        <bzg-icon [color]="'active'"
                  [@bzgHorizontalFlip]="!expanded[i]" nameIcon="arrow-up-special"
                  (click)="expanded[i] = expanded[i] ? false : true"
                  class="bmc-user-groups-conditions-header__icon-arrow"></bzg-icon>
      </div>
      <div class="bmc-user-groups-conditions-body bz-space--stack-m" [@bzgSlideDown] *ngIf="expanded[i]" >
        <div class="bmc-user-groups-conditions-body__options bz-color-border--neutral-300 bz-space--inline-m">
          <bzg-radio-group [(ngModel)]="condition.exclude" [disabled]="!menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageConditions]]">
            <bzg-radio-button [value]="false" (click)="updateIncludeExclue(condition, i, 'include')">{{'USER_GROUPS_CONDITIONS.INCLUDE' | translate}}</bzg-radio-button>
            <bzg-radio-button [value]="true" (click)="updateIncludeExclue(condition, i, 'exclude')">{{'USER_GROUPS_CONDITIONS.EXCLUDE' | translate}}</bzg-radio-button>
          </bzg-radio-group>
        </div>
        <div class="bmc-user-groups-conditions-body__conditions">
          <label>{{'USER_GROUPS_CONDITIONS.TITLE' | translate}}</label>
          <bzg-button-secondary *ngIf="menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageConditions]]" class="bmc-user-groups-conditions-body__conditions__button" (click)="openProperties(condition, i)" [size]="'s'">{{'USER_GROUPS_CONDITIONS.BTN_ADD_EDIT' | translate}}
          </bzg-button-secondary>
        </div>
      </div>
      <div class="bmc-user-groups-conditions-tags">
        <ng-container *ngFor="let conditionProperty of condition | keyvalue">
          <div class="bmc-user-groups-conditions-tags__tag bz-color-border--neutral-300 bz-space--inset-squish-s"
               [ngClass]="{'bmc-user-groups-conditions-tags__tag--read-only': !menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageConditions]]}" *ngIf="conditionProperty.value && condition[conditionProperty] !== null && properties && properties[conditionProperty.key] != undefined">
            <label class="bz-space--inline-s bz-font-size--body-small">{{("USER_GROUPS.PROPERTY_" + (conditionProperty.key | uppercase)) | translate}}: {{conditionProperty.value.displayName}} </label>
            <bzg-button-icon *ngIf="menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageConditions]]" [iconSize]="12" icon="icon-close" (click)="removeProperty(condition, conditionProperty.key)"></bzg-button-icon>
          </div>
        </ng-container>
      </div>
    </li>
</ul>

<div *ngIf="menuOptions && menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageConditions]]">
    <a class="bz-color--theme-400 bmc-user-groups-conditions__add-new" (click)="addNewCondition()">{{'USER_GROUPS_CONDITIONS.ADD_ANOTHER_CONDITION' | translate}}</a>
</div>

<!-- <bzg-button-primary (click)="openProperties()">Open properties</bzg-button-primary> -->
